import Utils from "@/utilities/Utils";
import { TriState, VisitStatus } from "@/model/Enums";

export class ClientSearchParameters {
    pageNumber: number = 1;
    id: string = Utils.emptyGuidValue;
    briefingID: string = Utils.emptyGuidValue;
    searchText: string = "";
    host: string = "";
    isDeleted: TriState = TriState.False;
}